{
    let slideMain = document.querySelector("slide-show");
    if (slideMain) {
        let sliderItems = document.querySelectorAll("slide-show-item");

        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let item = entry.target;
                    let linkElement = item.querySelector(".slideshow__slide-inner");
                    let outboundUrl = linkElement ? linkElement.getAttribute("href") : null;
                    let position = item.dataset.position;

                    if (outboundUrl && outboundUrl.includes("/products/")) {
                        const name = linkElement.getAttribute('data-product-title') || null;
                        const price = linkElement.getAttribute('data-product-price') || null;
                        const sku = linkElement.getAttribute('data-product-sku') || null;
                        const upc = linkElement.getAttribute('data-product-upc') || null;
                        const variant = linkElement.getAttribute('data-product-variant') || null;

                        tagular("ProductViewed", {
                            correlationId: null,
                            viewCorrelationId: null,
                            listId: null,
                            product: {
                                brand: "SHOP",
                                category: null,
                                coupon: null,
                                formatSubtype: null,
                                formatType: variant,
                                location: `Hero`,
                                name: name,
                                pageId: null,
                                position: parseInt(position),
                                price: parseFloat(price),
                                productId: null,
                                quantity: 1,
                                sku: sku,
                                subscription: {
                                    frequency: null
                                },
                                text: "Shop Now",
                                upc: upc,
                                variant: variant,
                                positionEngine: null
                            }
                        });
                    } else {
                        tagular("ElementViewed", {
                            webElement: {
                                elementType: "Banner",
                                htmlId: null,
                                location: "Hero",
                                name: "Hero Shop Now",
                                position: position,
                                text: null,
                                variant: null
                            }
                        });
                    }
                }
            });
        }, {
            threshold: 0.6// Fire when at least 50% visible
        });

        sliderItems.forEach((item) => {
            if (!item.hasAttribute("hidden") && !item.hidden) {
                observer.observe(item);
            }
        });
    }
}

{
    let viewButtons = document.querySelectorAll(".js-visible-view-button");

    if (viewButtons.length) {
        viewButtons.forEach(item => {
            item.addEventListener("click", function (e) {

                const productTile = item.closest(".product__header"); // change to your real wrapper selector
                if (!productTile) return;

                const headingEl = productTile.querySelector(".text-container .heading");
                const locationText = headingEl ? headingEl.textContent.trim() : null;
                const outboundUrl = item.querySelector("a").href || "";

                tagular("ElementClicked", {
                     actionOutcome: "INTERNALLINK",
                     outboundUrl: outboundUrl,
                    webElement: {
                        elementType: "Link",
                        htmlId: item.id || null,
                        location: locationText,
                        name: "View All",
                        position: null,
                        text: null,
                        variant: null
                    }
                });
            });
        });
    }
}

{
    document.addEventListener("DOMContentLoaded", () => {
        const trendingModules = document.querySelectorAll(".js-destination-guides");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    tagular("ElementViewed", {
                        webElement: {
                            elementType: "Module",
                            htmlId: null,
                            location: "Trending Destinations Guides",
                            name: "Trending Destinations Guides Module",
                            position: null,
                            text: null,
                            variant: null
                        }
                    });
                }
            });
        }, { threshold: 0.6 });

        trendingModules.forEach(module => observer.observe(module));
    });
}

{
    document.addEventListener('DOMContentLoaded', function () {
        const sections = document.querySelectorAll('.js-destination-guides');

        sections.forEach((section) => {
            const blocks = section.querySelectorAll('.accordion-block');
            const images = section.querySelectorAll('.destination-guides__right .image_block_box');
            const images_mobile = section.querySelectorAll('.accordion-content');

            blocks.forEach((block) => {
                block.addEventListener('click', function () {
                    const index = this.getAttribute('data-index');

                    // Remove active classes (scoped only to this section)
                    blocks.forEach((b) => b.classList.remove('active'));
                    images.forEach((img) => img.classList.remove('active'));
                    images_mobile.forEach((img) => img.classList.remove('active'));
                    destinationListClick(block, index);

                    // Add active class
                    this.classList.add('active');

                    const img = section.querySelector(`.destination-guides__right .image_block_box[data-index='${index}']`);
                    const img_mobile = section.querySelector(`.accordion-content[data-index='${index}']`);
                    if (img) img.classList.add('active');
                    if (img_mobile) img_mobile.classList.add('active');
                    productView(img, img_mobile)
                });
            });
        });
    });

    function destinationListClick(block) {
        let DestinationName = block.querySelector(".js-destination-name")?.textContent.trim() || "";
        let position = block.querySelector(".number")?.textContent.trim() || "";
        tagular("ElementClicked", {
            actionOutcome: "SELECT",
            outboundUrl: "",
            webElement: {
                elementType: "Button",
                htmlId: null,
                location: "Trending Destinations Guides",
                name: DestinationName,
                position: String(position),
                text: null,
                variant: null
            }
        });
    }

    function productView(img) {
        let productDetail = img.querySelector(".js-product-detail") || document.querySelectorAll(".js-product-detail")[0];
        if (!productDetail) return;
        let {
            productId,
            productPrice,
            productTitle,
            productSku,
            productUpc,
            productPosition,
            bookVersion // Assuming variant is stored here
        } = productDetail.dataset;
        let cleanPrice = productPrice ? parseInt(productPrice, 10) : null;
        let skuValue = productSku && productSku.trim() !== "" ? productSku : productId;

        tagular("ProductViewed", {
            correlationId: null,
            viewCorrelationId: null,
            listId: null,
            product: {
                brand: "SHOP",
                category: null,
                coupon: null,
                formatSubtype: null,
                formatType: null,
                location: "Trending Destinations Guides",
                name: productTitle || null,
                pageId: null,
                position: productPosition ? parseInt(productPosition, 10) : null,
                price: cleanPrice ,
                productId: productId || null,
                quantity: 1,
                sku: skuValue || null,
                subscription: {
                    frequency: null
                },
                text: null,
                upc: productUpc || null,
                variant: bookVersion || null,
                positionEngine: null
            }
        });
    }

    //  Function to send the ProductViewed event
    function sendProductViewed(item , outboundUrl) {
        if (!item) return;

        let {
            productId,
            productPrice,
            productTitle,
            productSku,
            productUpc,
            productPosition,
            bookVersion
        } = item.dataset;

        let cleanPrice = productPrice ? parseInt(productPrice, 10) : null;
        let skuValue = productSku && productSku.trim() !== "" ? productSku : productId;

        tagular("ProductClicked", {
            actionOutcome: "INTERNALLINK",
            outboundUrl: outboundUrl,
            correlationId: null,
            viewCorrelationId: null,
            listId: null,
            product: {
                brand: "SHOP",
                category: null,
                coupon: null,
                formatSubtype: null,
                formatType: null,
                location: "Trending Destinations Guides",
                name: productTitle || null,
                pageId: null,
                position: productPosition ? parseInt(productPosition, 10) : null,
                price: cleanPrice || null,
                productId: productId || null,
                quantity: 1,
                sku: skuValue,
                subscription: {
                    frequency: null
                },
                text: null,
                upc: productUpc || null,
                variant: bookVersion || null,
                positionEngine: null
            }
        });
    }

    //  Attach listeners for desktop & mobile products
        function productClick() {
        const allProducts = document.querySelectorAll(".destination-guides__right .image_block_box");

        allProducts.forEach((itemAll) => {
            const link = itemAll.querySelector("a");

            if (!link) return;

            link.addEventListener("click", () => {
            const item = itemAll.querySelector(".js-product-detail");
            const outboundUrl = link.href || "";                
            sendProductViewed(item,outboundUrl);
            });
        });
    }

document.addEventListener("DOMContentLoaded", productClick);


}

{
    let jsMediaContainers = document.querySelectorAll(".js-media-container");

    if (jsMediaContainers.length) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let item = entry.target;
                    let locationAttr = item.dataset.location || "Collections Module";

                    tagular("ElementViewed", {
                        webElement: {
                            elementType: "Module",
                            htmlId: null,
                            location: locationAttr,
                            name: locationAttr,
                            position: null,
                            text: null,
                            variant: null
                        }
                    });
                }
            });
        }, { threshold: 0.6 }); // Fires when 50% visible — adjust if needed

        jsMediaContainers.forEach((item) => observer.observe(item));
    }
}


{
    let mainShopByCollection = document.querySelectorAll(".js-media-container");

    if (mainShopByCollection.length) {
        mainShopByCollection.forEach((container) => {
            container.querySelectorAll(".js-slider").forEach((sliderItem, index) => {

                sliderItem.addEventListener("click", (e) => {
                    const headingEl = sliderItem.querySelector(".heading") || sliderItem.querySelector(".js-heading") || null;
                    let locationAttr = container.dataset.location
                        const headingText = headingEl?.innerText.replace(/\s+/g, " ").trim();

                        let outboundUrl = sliderItem.querySelector("a")?.href || sliderItem.href || "";
                        tagular("ElementClicked", {
                            actionOutcome: "INTERNALLINK",
                            outboundUrl: outboundUrl,
                            webElement: {
                                elementType: "Button",
                                htmlId: null,
                                location: locationAttr,
                                name: headingText,
                                position: String(index + 1),
                                text: null,
                                variant: null
                            }
                        });
                    

                });

            });
        });
    }
}

{
    let viewAllBooks = document.querySelectorAll(".js-view-all-books");
    if (viewAllBooks.length) {
        viewAllBooks.forEach((item, index) => {
            let clickMain = item.querySelector("a");
            if (!clickMain) return;

            clickMain.addEventListener("click", (e) => {
                let outboundUrl = clickMain.href || "";
                let buttonName = clickMain.innerText.replace(/\s+/g, " ").trim();

                tagular("ElementClicked", {
                    actionOutcome: "INTERNALLINK",
                    outboundUrl: outboundUrl,
                    webElement: {
                        elementType: "Button",
                        htmlId: null,
                        location: "Collections Module",
                        name: buttonName,
                        position: String(index + 1),
                        text: null,
                        variant: null
                    }
                });
            });
        });
    }
}

{
    document.addEventListener("DOMContentLoaded", function () {
        const form = document.querySelector(".newsletter__form");
        if (!form) return;

        const correlationID = Date.now().toString();
        let hasBeenVisible = false;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !hasBeenVisible) {
                      tagular("FormViewed", {
                        correlationID: null,
                        captureContext: {
                            capturePlacement: "Banner",
                            captureType: "Custom Form",
                            identityRequested: true
                        },  
                        // valueProp: "Newsletter",
                        formContext: {
                            formBrand: "LP",
                            formId: "NEWSLETTER-SHOP",
                            formName: "Newsletter - Shop Homepage",
                            formType: "Newsletter",
                            formVersion: null
                        }
                    });
                        hasBeenVisible = true;
                    } else if (!entry.isIntersecting) {
                        // reset so it can fire again if needed when re-entering viewport
                        hasBeenVisible = false;
                    }
                });
            },
            { threshold: 0.6 }
        );

        observer.observe(form);
    });
}

{
    document.addEventListener("DOMContentLoaded", function () {
        const lpinsiderBlocks = document.querySelectorAll(".js-lpinsider-block");
        if (!lpinsiderBlocks.length) return;

        lpinsiderBlocks.forEach((block) => {
            let isVisible = false;

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !isVisible) {
                            tagular("ElementViewed", {
                                webElement: {
                                    elementType: "Module",
                                    htmlId: null,
                                    location: "LP Insider Banner",
                                    name: "LP Insider Module",
                                    position: null,
                                    text: null,
                                    variant: null
                                }
                            });
                            isVisible = true;
                        } else if (!entry.isIntersecting) {
                            // Reset so it can fire again if needed
                            isVisible = false;
                        }
                    });
                },
                { threshold: 0.6 } // 25% of element must be visible
            );

            observer.observe(block);
        });
    });
}

{
    document.addEventListener("DOMContentLoaded", function () {
        const lpinsiderBlocks = document.querySelectorAll(".js-lpinsider-block");
        if (!lpinsiderBlocks.length) return;
        lpinsiderBlocks.forEach((block) => {
            const button = block.querySelector(".js-lp-banner-btn");
            if (!button) return;

            button.addEventListener("click", function (e) {
                const buttonText = block.querySelector(".js-button-text")?.innerText.trim() || "";
                const outboundUrl = button.getAttribute("href") || "";

                tagular("ElementClicked", {
                    actionOutcome: "INTERNALLINK",
                    outboundUrl: outboundUrl,
                    webElement: {
                        elementType: "Button",
                        htmlId: null,
                        location: "LP Insider Banner",
                        name: buttonText,
                        position: null,
                        text: null,
                        variant: null
                    }
                });

            });
        });
    });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".newsletter__form");
    if (!form) return;
    const emailInput = form.querySelector("input[name='contact[email]'], input[name='email']");
    const submitBtn = form.querySelector(".js-newsletter-button");
    const errorMsg = form.querySelector(".email-error");
    const errorIcon = form.querySelector(".email-error-icon");
    if (!emailInput || !submitBtn) return;

    const API = "https://www.lonelyplanet.com/api/external/newsletter";

    function validateEmail(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      return re.test(email);
    }

    async function sha256Hex(text) {
      const data = new TextEncoder().encode(text);
      const digest = await crypto.subtle.digest("SHA-256", data);
      return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, "0")).join("");
    }

    form.addEventListener("submit", function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      return false;
    }, true);

    submitBtn.addEventListener("click", async function () {
      const emailValue = (emailInput.value || "").trim();

      if (emailValue === "") {
        if (errorMsg) errorMsg.style.display = "none";
        if (errorIcon) errorIcon.style.display = "none";
        return;
      }

      if (!validateEmail(emailValue)) {
        if (errorMsg) errorMsg.style.display = "block";
        if (errorIcon) errorIcon.style.display = "block";
        return;
      }

      if (errorMsg) errorMsg.style.display = "none";
      if (errorIcon) errorIcon.style.display = "none";

      formStarted();

      const emailHash = await sha256Hex(emailValue.toLowerCase());

      const fd = new FormData();
      fd.append("email", emailValue);
      fd.append("email_hash", emailHash);
      fd.append("hash_alg", "SHA-256");
      fd.append("source", "NL-HOMEPAGE");
      fd.append("formName", "NEWSLETTER-SHOP");

      fetch(API, { method: "POST", body: fd, credentials: "include" })
        .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
        .then(function(){
          submitForm();
        })
        .catch(function(){
          form.setAttribute("data-state","error");
        });
    });

    emailInput.addEventListener("input", function () {
      const emailValue = (emailInput.value || "").trim();
      if (emailValue === "" || validateEmail(emailValue)) {
        if (errorMsg) errorMsg.style.display = "none";
        if (errorIcon) errorIcon.style.display = "none";
      }
    });

    emailInput.addEventListener("focus", function () {
      formStarted();
    });
  });

  function formStarted() {
    tagular("FormStarted", {
      correlationID: null,
      captureContext: {
        capturePlacement: "Banner",
        captureType: "Custom Form",
        identityRequested: true
      },
      formContext: {
        formBrand: "LP",
        formId: "NEWSLETTER-SHOP",
        formName: "Newsletter - Shop Homepage",
        formType: "Newsletter",
        formVersion: null
      }
    });
  }

  function submitForm() {
    tagular("FormSubmitted", {
      correlationID: null,
      captureContext: {
        capturePlacement: "Banner",
        captureType: "Custom Form",
        identityRequested: true
      },
      formContext: {
        formBrand: "LP",
        formId: "NEWSLETTER-SHOP",
        formName: "Newsletter - Shop Homepage",
        formType: "Newsletter",
        formVersion: null
      }
    });
  }
}
